interface NavigationData{
    title:string,
    link:string
}
const baseUrl= process.env.NODE_ENV=='production'? '/':'/'
const navData:NavigationData[]= []

export {
    baseUrl,
    navData
}